import { createSelector } from 'reselect'
import { getPageData } from './page'

export const getIsArtistOnboarded = createSelector(
  [getPageData],
  (page): boolean => page?.isArtistOnboarded || false
)
